import { Text } from 'react-native'

import { styled } from '~/core/styled'
import { convertLineHeight, convertPercentageToNumber } from '~/utils'

export const Label = styled(Text, theme => {
  return {
    base: {
      height: theme.sizingExtrasmall,

      fontSize: theme.fontSizeThreeandhalfpulse,
      fontFamily: theme.fontFamily.regular,
      color: theme.colorTextNeutralDefault,

      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),

      lineHeight: convertLineHeight(
        theme.fontSizeThreeandhalfpulse,
        theme.lineHeightSmall
      ),

      paddingHorizontal: theme.paddingInsetOnepulse,
    },
    variants: {
      isDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      isReadOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
      size: {
        md: {
          fontSize: theme.fontSizeThreepulse,
        },
        ml: {},
        lg: {},
        xl: {},
      },
    },
  }
})
